import { render, staticRenderFns } from "./LogisticsTracking.vue?vue&type=template&id=39154a64&scoped=true"
import script from "./LogisticsTracking.vue?vue&type=script&lang=js"
export * from "./LogisticsTracking.vue?vue&type=script&lang=js"
import style0 from "./LogisticsTracking.vue?vue&type=style&index=0&id=39154a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39154a64",
  null
  
)

export default component.exports